import { render, staticRenderFns } from "./ExtraMobilePage.vue?vue&type=template&id=956dceb0&"
import script from "./ExtraMobilePage.vue?vue&type=script&lang=js&"
export * from "./ExtraMobilePage.vue?vue&type=script&lang=js&"
import style0 from "./ExtraMobilePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports